import AssetConnectivityTable from './AssetConnectivityTable';

export { AssetConnectivityTable };
export default AssetConnectivityTable;
